<template>
    <EditWindow heading="Edit user" :name="full_name(user)" :layer="1010"
                @close="emit('close')" @saved="emit('saved')">

        <EditSection title="Name & sign-in">
            <EditField :object="user" field="first_name" label="First name"/>
            <EditField :object="user" field="last_name" label="Last name"/>
            <EditField :object="user" field="username" label="Username"/>
        </EditSection>

        <EditSection title="Password">
            <EditPassword :user="user"/>
        </EditSection>

        <EditSection title="Contact">
            <EditField :object="user" field="cellphone" label="Cellphone" type="tel"
                       hint="WhatsApp messages go here. Spaces, dashes, dots and brackets are removed."/>
            <EditField :object="user" field="whatsapp" label="WhatsApp" readonly :href="whatsapp_link"
                       hint="Built from the cellphone."/>
            <EditField :object="user" field="email" label="Email" type="email"/>
        </EditSection>

        <EditSection title="Profile">
            <EditField :object="user" field="gender" label="Gender" :suggestions="genders"/>
            <EditField :object="user" field="age" label="Age" type="number" step="1"/>
            <EditField :object="user" field="location" label="Location"/>
            <EditField :object="user" field="origin" label="Origin"/>
            <EditField :object="user" field="timezone" label="Time zone" placeholder="Mexico Central"/>
        </EditSection>

        <EditSection title="Access">
            <EditField :object="user" field="role" label="Role" type="select" :options="roles"
                       hint="Decides which dashboard they get. Admin can see and change everything."/>
            <EditField :object="user" field="is_active" label="Active" type="checkbox"
                       hint="Off = they cannot sign in."/>
            <EditField :object="user" field="tutorial" label="Tutorial seen" type="checkbox"
                       hint="Off = the instructor dashboard tutorial plays again."/>
            <EditField :object="user" field="last_login" label="Last login" readonly :display="when"/>
        </EditSection>

        <EditSection title="Advanced" note="Rarely needed. The dashboard ignores the three Django flags - access comes from Role.">
            <EditField :object="user" field="is_admin" label="is_admin" type="checkbox"/>
            <EditField :object="user" field="is_staff" label="is_staff" type="checkbox"/>
            <EditField :object="user" field="is_superuser" label="is_superuser" type="checkbox"/>
            <EditField :object="user" field="ai_thread" label="Monica conversation ID" wide
                       hint="Where Monica's conversation with this person picks up. Clear it and her next reply starts fresh."/>
        </EditSection>

        <EditSection title="Notes">
            <EditField :object="user" field="comments" label="Comments" type="textarea"/>
        </EditSection>

    </EditWindow>
</template>


<script setup>

    import EditWindow from '@/components/edit/EditWindow.vue'
    import EditSection from '@/components/edit/EditSection.vue'
    import EditField from '@/components/edit/EditField.vue'
    import EditPassword from '@/components/edit/EditPassword.vue'
    import {full_name} from '@/components/edit/helpers.js'

    defineProps({
        user:{type:Object,required:true},
    })
    const emit=defineEmits(['close','saved'])

    // The roles the code branches on. `role` is free text, so a stored value outside this list
    // ('' or 'STUDENT' today) still shows as it is until someone picks one.
    const roles=['Student','Instructor','Lead','Admin']
    const genders=['F','M']

    function when(value){
        if(!value){
            return 'Never'
        }
        return new Date(value).toLocaleString('en-US',{timeZone:'America/Mexico_City',dateStyle:'medium',timeStyle:'short'})
    }

    function whatsapp_link(value){
        return value ? `https://${value.replace(/^https?:\/\//i,'')}` : null
    }

</script>
